import React, { useMemo } from "react";
import { TRecipientData } from "../../../../stores/RecipientStore";
// import { useRecipientStore } from '../../../recipient/ui/store';
import redirectTo from "../../../../utils/redirectTo";
import styles from "./DonorNeedCard.module.scss";
import {
  SHORT_BLOOD_WAITING,
  WAITING_BLOOD_CLASES,
} from "../../../../entities";
import moment from "moment";
import UserAvatar from "../../../ui/userAvatar";
import { inject, observer } from "mobx-react";
import Button from "../../ui/button/Button";

const LOCAL_BLOOD_CLASSES = {
  ...WAITING_BLOOD_CLASES,
  leukocytes: {
    title: "Гранулоциты",
    icon: "/static/images/icons/leukocytes.svg",
    not_approved_icon: "/static/images/icons/not_approved_leukocytes.svg",
  },
  any: {
    title: "Любой компонент",
    icon: "/static/images/icons/allComponents.svg",
  },
};

const LOCAL_SHORT_BLOOD_WAITING = {
  ...SHORT_BLOOD_WAITING,
  any: "Любая группа крови",
};

const DonorNeedCard: React.FC<{
  data: TRecipientData;
  recipientStore: any;
  // past?: boolean;
}> = ({
  data,
  recipientStore,
  // past = false
}) => {
  const { getRecipientBloodNeedsByRecipientId } = recipientStore;
  // get only needs
  const needs = useMemo(() => {
    return getRecipientBloodNeedsByRecipientId(data);
  }, [data]);

  const joined_users = data.joined_users.filter((_, idx) => idx < 3);

  const usersPhotos = joined_users.slice(0, 3).map((user, i) => (
    // i <= 2 &&
    <UserAvatar user={user.user} scale={34} key={user.user.id} />
  ));

  const onClick = () => {
    redirectTo(
      `/recipient/${data.id}/?utm_source=profile&utm_medium=recipient&utm_campaign=donor_search`
    );
  };

  // const name = useMemo(() => {
  //   const full = [data.last_name, data.first_name].filter(Boolean).join(" ");
  //   if (full.length >= 18) {
  //     return `${full.slice(0, 18)}...`;
  //   } else {
  //     return full;
  //   }
  // }, [data.first_name, data.last_date]);
  console.log(data.total_joined_count > 1);
  return (
    <>
      {/* шапка карточки */}
      <div className={styles.header}>
        {/* название и дата */}
        <div className={styles.header__top}>
          {/* иконка */}
          <img
            className={styles.blood_icon}
            src={LOCAL_BLOOD_CLASSES[data.blood_class].icon}
            alt={LOCAL_BLOOD_CLASSES[data.blood_class].title}
          />
          {/* название */}
          <span className={styles.blood_class}>
            {LOCAL_BLOOD_CLASSES[data.blood_class].title}
          </span>
          {/* дата */}
          <span className={styles.date}>
            {moment(data.last_date).format("[До] D MMMM")}
          </span>
        </div>
        {/* лейблы нужд групп крови */}
        <div className={styles.header__middle}>
          {/* набор лейблов */}
          {needs?.length < 8 ? (
            needs?.map((item) => (
              <div
                className={styles.bloodGroup_shield}
                key={`${item.name}_${item.value}`}
              >
                <span>{LOCAL_SHORT_BLOOD_WAITING[item.name]}</span>
              </div>
            ))
          ) : (
            <div className={styles.DonorNeedCardNeed}>
              <span>{LOCAL_SHORT_BLOOD_WAITING.any}</span>
            </div>
          )}
        </div>
        {/* имя реципиента */}
        <div className={styles.header__bottom}>
          <span>Реципиент:</span>
          <p className={styles.recipientName}>{data.first_name}</p>
          {/* <span>{past ? "Поиск донора" : name}</span> */}
        </div>
      </div>
      {/* тело карточки */}
      <div className={styles.body}>
        {/* кто ищет */}
        {data.author && (
          <div className={styles.author}>
            <span>Ищет</span>

            <div className={styles.author__item}>
              <UserAvatar
                field={"image"}
                scale={48}
                user={data.author}
                style={{
                  width: "auto",
                  marginRight: 16,
                }}
              />

              <span className={styles.author__name} title={data.author.name}>
                {data.author.name}
              </span>
            </div>
          </div>
        )}
        {/* адрес того кто ищет */}
        <div className={styles.address}>
          <div className={styles.address__icon}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
                stroke="#4E5355"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
                stroke="#4E5355"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <span
            className={styles.address__text}
            title={[
              data?.blood_station?.city?.title,
              data?.blood_station?.address,
            ]
              .filter(Boolean)
              .join(", ")}
          >
            {[data?.blood_station?.city?.title, data?.blood_station?.address]
              .filter(Boolean)
              .join(", ")}
          </span>
        </div>
      </div>
      {/* подвал карточки */}
      <div className={styles.footer}>
        {/* кто записался */}
        <div className={styles.userList}>
          <span className={styles.userList__count}>
            {data.total_joined_count}/{data.required_donors_count}
            {data.total_joined_count === 1
              ? " уже идёт"
              : !data.total_joined_count
              ? ", станьте первым!"
              : " уже идут"}
          </span>

          <div className={styles.userList__photos}>
            {usersPhotos.map((photo) => photo)}
          </div>
        </div>
        {/* ссылка для перехода */}
        <Button children={"Откликнуться"} onClick={onClick} />
      </div>
    </>
  );
};

// export default DonorNeedCard

export default inject(
  // 'randomActivitiesStore',
  // 'eventStore',
  "recipientStore"
  // 'bloodStationsNeedStore'
)(observer(DonorNeedCard));
